/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from 'react'
import FooterButtons from './components/footerButtons'
import { Container, Divider } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { ACTION_COMPLETE, DETAILS, FEEDBACK, REVIEW } from './pages'
import SuspendPanel from './components/suspend-panel'
import TimePanel from './components/time-panel'
import FeedbackPage from './pages/feedback'
import DetailsPage from './pages/details'
import CompleteHeader from './components/complete-header'
import SuspensionCompletePage from './pages/suspend-complete'
import ReviewPage from './pages/review'
import CancelCompletePage from './pages/cancel-complete'
import WaitingDialog from '../../../../../../components/waiting-dialog'
import Suspend from './components/suspend'
import { useSubscription } from '../../hooks/useSubscription'
import { useRetention } from './hooks/useRetention'
import { SubscriptionProvider } from '../../context'
import useAccountInfo from '../../hooks/useAccountInfo'
import DiscountCompletePage from './pages/discount-complete'
const useStyles = makeStyles(
  ({ spacing, palette, typography, breakpoints }) => ({
    container: {
      marginTop: spacing(4.5),
      [breakpoints.down('md')]: {
        padding: spacing(0, 6)
      },
      [breakpoints.down('sm')]: {
        padding: spacing(0, 2)
      },
      [breakpoints.down(375)]: {
        padding: spacing(0, 1)
      }
    },
    divider: {
      position: 'relative',
      marginTop: spacing(8),
      [breakpoints.down('sm')]: {
        marginTop: spacing(4)
      },
      left: 0
    }
  })
)

const Content = props => {
  const classes = useStyles()
  const [reason, setReason] = useState('')
  const [comment, setComment] = useState('')
  const {
    state: { activePage, action },
    dispatch
  } = useRetention()

  const { handleCancel, handleSuspend, subscriptionChangePending, suspension, discount } =
  useSubscription()

  const { isMonthlyPlan, canSuspend } = useAccountInfo()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [activePage])

  const stepComplete = activePage === FEEDBACK ? !!reason : true

  const renderDivider =
    activePage !== ACTION_COMPLETE || action !== 'cancellation'

  const getPage = () => {
    if (activePage === FEEDBACK) {
      return <FeedbackPage reason={reason} comment={comment} setComment={setComment} onReasonChange={setReason} />
    }
    if (activePage === DETAILS) {
      const suspend = isMonthlyPlan() && canSuspend() ? <Suspend onSuspend={() => handleSuspend({ reason, comment })} /> : null
      const rightPanel = reason === 'time'
        ? <TimePanel suspend={suspend} />
        : suspend ? <SuspendPanel suspend={suspend} /> : null
      return <DetailsPage rightPanel={rightPanel} />
    }
    if (activePage === REVIEW) {
      return <ReviewPage />
    }
    if (activePage === ACTION_COMPLETE) {
      if (action === 'suspension') {
        return (
          <SuspensionCompletePage
            header={
              <CompleteHeader title="You're all set - Your subscription suspension is scheduled" />
            }
            suspension={suspension}
          />
        )
      }
      if (action === 'cancellation') {
        return <CancelCompletePage />
      }
      if (action === 'discount') {
        return <DiscountCompletePage discount={discount} />
      }
    }
  }

  const handleCancelConfirm = () => {
    handleCancel({ reason, comment })
  }

  return (
    <>
      <Container maxWidth='md' disableGutters className={classes.container}>
        {getPage()}
      </Container>
      {renderDivider && <Divider className={classes.divider} />}
      <Container maxWidth='md' disableGutters className={classes.container}>
        <FooterButtons
          stepComplete={stepComplete}
          onCancelConfirm={handleCancelConfirm}
          onContinue={() => dispatch({ type: 'continueButton' })}
          onPrevious={() => dispatch({ type: 'previousButton' })}
          onNoThanks={() => dispatch({ type: 'noThanksButton' })}
        />
      </Container>
      {!!subscriptionChangePending && (
        <WaitingDialog
          open={!!subscriptionChangePending}
          titleId='suspendInProgressDialog'
          title='Updating your subscription'
        />
      )}
    </>
  )
}

const Retention = () => {
  return (
    <SubscriptionProvider>
      <Content />
    </SubscriptionProvider>
  )
}
export default Retention
